import { AsyncTask } from '../async-task';
import { BizData } from '../data';
export namespace Import {
    /** 导入任务状态 */
    export const enum ExportState {
        /** 等待中 */
        Waiting = 0,

        /** 进行中 */
        Running = 1,

        /** 成功 */
        Success = 2,

        /** 失败 */
        Fail = 3,

        /** 取消 */
        Cancel = 4,
    }

    // 导入激活面板
    export enum ImportActiveKey {
        Data = 'importData', // 导入数据
        History = 'importHistory', // 导入记录
    }

    // 导入数据状态
    export enum ImportDataStatus {
        Draft = 0, // 草稿
        Effective = 1, // 生效
        Processing = 2, // 发起流程
    }

    // 导入类型
    export enum ImportType {
        Upsert = 0, // 混合模式
        InsertOnly = 1, // 新增模式
        UpdateOnly = 2, // 更新模式
    }

    export namespace Request {
        export interface IGetSheetData {
            Rows: number;
            SheetName: string;
            ImportGuid: string | undefined;
            ActionName: string;
        }
        export interface ICheckPropertyFields {
            appCode: string;
            sheetName: string;
            importGuid: string | undefined;
            ActionName: string;
            selectRow: number;
            fields: object;
        }
        export interface IGenerateSchema {
            appCode: string;
            sheetName: string | undefined;
            displayName: string;
            groupCode?: string;
            iconCss: string;
            titleRowNum: number | undefined;
            importGuid: string | undefined;
            fields: object[];
        }
        export interface IGetGenerateSchemaProgress {
            ImportGuid: string | undefined;
            ActionName: string;
        }
        export interface IAbortGenerateSchemaImport {
            ImportGuid: string;
            ActionName: string;
        }
        export interface IClearCache {
            ImportGuid: string | undefined;
            ActionName: string;
        }

        export type QueryMatchType = {
            type: string;
            matchers: QueryMatchItem[];
        };

        export type QueryMatchItem = {
            id?: string;
            editable?: boolean;
            name?: string;
            type?: string;
            operator: BizData.Filter.ComparisonOperatorType;
            value?: string;
        };

        // 导入数据添加异步任务请求参数
        export interface IAddImportTaskParams {
            asyncTaskId: string; // 异步任务ID, 1到30个字符
            schemaCode: string; // 表单编码
            bizObjectStatus: ImportDataStatus; // 业务对象状态
            workflowNotify: boolean; // 流程是否发通知
            importType: ImportType; // 导入类型
            importFileName: string; // 导入文件名, .csv文件名
            isContainSub: boolean; // 是否包含子表， 后端会重算
            totalLineCount: number; // 总行数， 包括标题行、编码行，可传0，后端会重算
            codeRowIndex: number; // 编码行索引 （模板中隐藏行）
            titleRowIndex: number; // 标题行索引
            recordDelimiter: string; // 记录分隔符
            fieldDelimiter: string; // 字段/列分隔符
            // DataTitleDelimiter: string; // 数据标题分割符
            multiSelectDelimiter: string; // 多选分隔符
            enabledEditableValidate: boolean; // 启用可写校验
            enabledRequiredValidate: boolean; // 启用必填校验
            enabledCalc: boolean; // 启用计算规则
            enabledEmptyCellTriggerCalc: boolean; // 启用空值触发计算
            enabledDataRangeCheck: boolean; // 启用数据范围校验
            enabledMergeMainTable: boolean; // 启用合并主表
            enabledLocationSplit: boolean; // 启用地址拆分
            enabledAddressSplit: boolean;
            enabledSubmitRule: boolean; // 启用提交规则
            enabledBusinessRule: boolean; // 启用业务规则，默认true
            enabledAutomation: boolean; // 启用自动化
            enabledWorkflowCustomCode: boolean; // 启用工作流代码执行
            tempOssFile: string; // 导入的文件临时存储路径
            viewPageId?: string; // 标签页id(多视图)
            ignoreCalculationError: boolean; // 是否忽略计算错误
            associationFilterMap?: Record<string, any>; // 关联过滤器
        }
    }
    export namespace Response {
        export interface IGetImportTemplate {
            OSSUrl: string;
        }
        export interface IGetSheetData {
            Rows: object;
        }
        export interface ICheckPropertyFields {
            FunctionGroup: object;
            PropertyFields: object;
        }
        export interface IGenerateSchema {
            SchemaCode: string;
        }
        export interface IGetGenerateSchemaProgress {
            SchemaCode: string;
            ImportProgress: number;
            ImportState: number;
            ImportSuccessCount: number;
            ImportErrorMsg?: string;
        }
        /** 日志记录模型 */
        export type RecordDetailModel = {
            /** 操作id */
            actionGuid: string;

            /** 表单编码 */
            schemaCode: string;

            /** 表单名称 */
            displayName: string;

            /** 文件名称 */
            fileName: string;

            /** 进度百分比 */
            percent: number;

            /** 错误报告地址 */
            errorRecordPath: string;

            /** 记录类型（这个指示导入、导出类型） */
            recordType: number;

            /** 导出文件地址 */
            fileUrl: string;

            /** 记录类型名称 */
            recordTypeName: string;

            /** 任务状态 */
            taskState: ExportState;

            /** 创建时间 */
            createdTime: number;

            /** unknown */
            remark: string;

            /** 是否存在失败的记录 */
            hasFailRecords: boolean;

            /** 跳过的数量 */
            skipQuantity: number;

            /** 前面还在等待的任务数 */
            wattingTasks: number;
        };

        export interface ITaskRecordModel {
            objectId: string; // 任务Id
            title: string; // 任务标题
            totalCount: number; // 总数量
            finishedCount: number; // 已完成数量
            asyncTaskState: AsyncTask.TaskState; // 异步任务状态
            createdBy: string; // 创建人
            errorMessage: string; // 错误信息
            createdTime: string; // 创建时间
            modifiedTime: string; // 修改时间
            errorFilePath: string; // 错误文件路径
            importBoCount: number; // 已处理的导入数据总量
            importType: ImportType; // 导入类型
            successBoCount: number; // 已导入成功的业务数据量
            errorBoCount: number; // 已导入失败的业务数据量
            downloadErrorExcelFile: string; // 下载错误Excel文件的URL
            downloadErrorCsvFile: string; // 下载错误CSV文件的URL
            downloadFilePath: string; // 下载成功文件的URL
            subTableErrorCount: Record<string, number>; // 子表错误记录
            subTableSuccessCount: Record<string, number>; // 主表错误记录
            runningTime: string; // 任务开始时间
            aheadTaskCount: number; // 前面还在等待的任务数
        }
        export interface IImportConfigResponse {
            isCustomStatus: boolean; // 是否支持自定义设置导入数据状态
            dataStatus: ImportDataStatus; // 默认导入的非流程表单数据状态
            workflowDataStatus: ImportDataStatus; // 默认导入的流程表单数据状态
            isNodeNotify: boolean; // 是否开启节点通知
            isValueValidate: boolean; // 是否开启字段值校验
            isSubmitValidate: boolean; // 是否开启提交校验
            isFieldCalc: boolean; // 是否开启字段计算
            isDataLinkage: boolean; // 是否开启数据联动
        }
    }
}
